import React, { useState } from 'react';
import CustomInputField from '../../components/CustomInput/CustomInputField';
import CustomFileUpload from '../../components/CustomInput/CustomFileUpload';
import MobCamera from '../../components/MobUpaod/MobCamera';
import { FileUploadHandlers } from '../KYCGuider/FileSpec';
import { UploadFile } from '../KYCGuider/FileUpload';
import { CloseEvent } from '../KYCGuider/CloseEvent';
import { OCREvent } from '../KYCGuider/OCREvent';
import Checked from '../../images/icons/checkbox_ok.svg';
import Onload from '../../images/icons/loading2.svg';
import NotOK from '../../images/icons/verification_failed.svg';
import NotVerified from '../../images/icons/not_verified.svg';
import { getUserId } from '../../common/utils/cookie-utils';
import window from 'window-or-global';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import CommonDatePicker, {
  currentYear
} from '../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import { UpdateKYCstepAPI } from '../../common/constants/api';
import FileUpload from '../../images/icons/file_upload.svg';

const Months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const PAN = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    status,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = useFormikContext();
  const [name_editable, setName_editable] = useState(true);
  const [father_name_editable, setFather_name_editable] = useState(true);
  const [pan_no_editable, setPan_no_editable] = useState(true);
  const [dob_editable, setDob_editable] = useState(true);
  const [file_id, setFileId] = useState('pan_card');
  const [submit, setSubmit] = useState(false);

  const setChanged = ocr_data => {
    let ocr = ocr_data.kycEntries;
    let dob = ocr.dob.value.toString();
    dob = dob.split('/');

    setFieldValue('name', ocr.name.value),
      setFieldValue('pan_no', ocr.panNumber.value),
      setFieldValue('father_name', ocr.fatherName.value),
      setFieldValue(
        'date',
        {
          value: ocr.dob.editable ? '' : dob[0],
          label: ocr.dob.editable ? 'Date' : dob[0]
        },
        true
      );
    setFieldValue(
      'month',
      {
        value: ocr.dob.editable ? '' : Months[parseInt(dob[1]) - 1],
        label: ocr.dob.editable ? 'month' : Months[parseInt(dob[1]) - 1]
      },
      true
    );
    setFieldValue(
      'year',
      {
        value: ocr.dob.editable ? String(currentYear - 18) : dob[2],
        label: ocr.dob.editable ? String(currentYear - 18) : dob[2]
      },
      true
    );

    setName_editable(ocr.name.editable),
      setPan_no_editable(ocr.panNumber.editable),
      setFather_name_editable(ocr.fatherName.editable),
      setDob_editable(ocr.dob.editable);
  };

  const file_checker_not_ok = (id, error_message) => {
    if (window.innerWidth > 768) {
      let doc_error = document.getElementById(id + '_error');
      doc_error.style.display = 'block';
      doc_error.innerHTML = error_message;
      //change karne
      setTimeout(() => {
        document.getElementById(id + '_image').src = FileUpload;
      }, 500);
    }
  };

  const file_checker_ok = res => {
    let data = {
      partnerId: parseInt(getUserId()),
      kycStepId: 1,
      docTypeId: 1,
      fileType: 'png'
    };
    UploadFile(res, data, Upload_ok, Upload_not_ok);
  };

  const Upload_ok = res => {
    UpdateKYCstepAPI({
      url: res.url,
      requestId: res.requestId
    }).catch(err => {});

    if (window.innerWidth > 768) {
      document.getElementById(file_id + '_image').src = Checked;
      document.getElementById(file_id + '_image').style.width = '28px';
      document.getElementById('web_pan_image').src = NotVerified;
      document.getElementById('web_pan_message').innerHTML =
        'Verification is Pending';
      document.getElementById('web_pan_message').style.color = 'orange';
    }
    try {
      let pan_file = ['pan_card'];

      CloseEvent(pan_file, close_event_ok, close_event_not_ok);
    } catch (e) {}
    try {
      let data = { partnerId: parseInt(getUserId()), fileName: res.fileName };
      OCREvent(data, ocr_ok, ocr_not_ok);
    } catch (e) {}
  };

  const Upload_not_ok = res => {
    if (window.innerWidth > 768) {
      try {
        document.getElementById(file_id + '_image').src = NotOK;
        document.getElementById(file_id + '_image').style.width = '28px';
      } catch {}
    }
  };

  const ocr_ok = res => {
    setChanged(res);
  };

  const ocr_not_ok = () => {};

  const close_event_ok = () => {
    setSubmit(true);
  };

  const close_event_not_ok = () => {};

  const FileUploadHandler = id => {
    // Hide the visibility of the upload docs area
    if (window.innerWidth > 768) {
      document.getElementById(id + '_area').style.display = 'none';
      document.getElementById(id + '_image').src = Onload;
      document.getElementById(id + '_image').style.width = '28px';
    }
    try {
      // Upload the file

      FileUploadHandlers(id, file_checker_ok, file_checker_not_ok);
    } catch (e) {}
  };

  return (
    <div className="w-full">
      <div
        className=" hidden w-full px-2 block md:block  bg-white   rounded-lg md:mx-auto  pt-8"
        id="doc_list_container"
      >
        <div className="w-full md:flex md:px-4 px-1 md:w-2/4 block">
          <div className="block md:hidden px-12 text-center mx-auto font-roboto font-bold">
            <p className="text-black-600 text-basic " id="pan_card_name"></p>
            <img
              className="md:w-3/4 mt-6 mb-8 mx-auto"
              id="card_photo"
              src=""
            />
            <iframe
              className="md:w-3/4 mt-6 mb-8 mx-auto hidden"
              id="card_photo_iframe"
              src=""
            ></iframe>
          </div>
        </div>
        <div className="w-full flex" id="doc_value_container">
          <div
            className="w-full md:flex  hidden md:block bg-grey-0 px-4  md:px-0 md:bg-white rounded-lg  mx-auto "
            id="upload_container"
          >
            <div className="w-1/2 mx-auto mt-10">
              <CustomFileUpload
                val={{ id: 'pan_card', file_caption: 'upload  PAN' }}
                file_handler={FileUploadHandler}
              />
            </div>
          </div>
          <div
            className="w-full md:w-2/4 md:hidden  visible  mx-auto md:block pt-3"
            id="doc_values_division"
          >
            <div className="mt-10">
              <CommonInput
                name="name"
                disabled={!name_editable}
                onChange={name_editable ? handleChange : null}
                onBlur={handleBlur}
                value={values.name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Full Name as per PAN"
                error={touched.name && errors.name}
                errorMsg={errors.name}
                touched={touched.name}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="pan_no"
                disabled={!pan_no_editable}
                onChange={pan_no_editable ? handleChange : null}
                onBlur={handleBlur}
                value={values.pan_no}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="PAN Number"
                error={touched.pan_no && errors.pan_no}
                errorMsg={errors.pan_no}
                touched={touched.pan_no}
              />
            </div>
            <div className="mt-10">
              <CommonInput
                name="father_name"
                disabled={!father_name_editable}
                onChange={father_name_editable ? handleChange : null}
                onBlur={handleBlur}
                value={values.father_name}
                stylesContainer={{
                  height: '52px',
                  maxWidth: '100%'
                }}
                legendName="Fathers Name"
                error={touched.father_name && errors.father_name}
                errorMsg={errors.father_name}
                touched={touched.father_name}
              />
            </div>
            <div className="w-full mt-5">
              <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                DOB
              </div>
              <CommonDatePicker
                onChangeMonth={(value, isValidDate) => {
                  dob_editable ? setFieldValue('month', value, true) : null;
                  setFieldTouched('month', true, false);
                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeYear={(value, isValidDate) => {
                  dob_editable ? setFieldValue('year', value, true) : null;
                  setFieldTouched('year', true, false);

                  if (!isValidDate) {
                    setFieldValue(
                      'date',
                      {
                        value: '',
                        label: 'Date'
                      },
                      true
                    );
                  }
                }}
                onChangeDate={value => {
                  dob_editable ? setFieldValue('date', value, true) : null;
                  setFieldTouched('date', true, false);
                }}
                valueMonth={values.month}
                valueYear={values.year}
                valueDate={values.date}
                errorYear={touched.year && get(errors, 'year.value', false)}
                touchedYear={touched.year}
                onBlurYear={() => {
                  setFieldTouched('year', true, true);
                }}
                errorMonth={touched.month && get(errors, 'month.value', false)}
                touchedMonth={touched.month}
                onBlurMonth={() => {
                  setFieldTouched('month', true, true);
                }}
                // errors.date.value
                errorDate={touched.date && get(errors, 'date.value', false)}
                touchedDate={touched.date}
                onBlurDate={() => {
                  setFieldTouched('date', true, true);
                }}
                //  errorMsg= "DOB is not selected"
                type="dob"
              />
            </div>
          </div>
        </div>
      </div>
      <MobCamera
        input_component="pan_card_m"
        main_id="upload_front"
        onchange={FileUploadHandler}
        caption="Upload From"
      />
      {submit ? (
        <button
          className=" submitButton w-56
                                lg:w-80  "
          type="submit"
          id="submit"
          disabled={
            errors.name ||
            errors.pan_no ||
            errors.father_name ||
            get(errors, 'month.value', false) ||
            get(errors, 'year.value', false) ||
            get(
              errors,
              'date.value',
              false ||
                values.name == '' ||
                values.pan_no == '' ||
                values.father_name == '' ||
                values.date.value == '' ||
                values.month.value == '' ||
                values.year.value == ''
            )
          }
        >
          CONTINUE
        </button>
      ) : null}
    </div>
  );
};
export default PAN;
